module.exports = {
      id: "facebook-icon-usage",
      viewBox: "0 0 135.08 135.08",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#facebook-icon",
      toString: function () {
        return this.url;
      }
    }